export const DashboardEndPoint = {
    GET_DASHBOARD_ADMIN: 'admin/activity/statistic',
}